import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardHeader } from '@/components/NCCard/NCCard';
import { SpeciesDetectedExplainer } from '@/components/NCExplainers/SpeciesDetectedExplainer';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';

import { SpeciesDetectedData, TableTile } from './components/TableTile';

export const SpeciesDetectedCard = () => {
  const { t } = useTranslation();

  const speciesDetectedFact = useFact<SpeciesDetectedData[]>('r1_conservation_species_detected');
  const hasData = speciesDetectedFact?.value && speciesDetectedFact.value.length > 0;

  if (!hasData) {
    return null;
  }

  return (
    <NCCard explainer={<SpeciesDetectedExplainer />}>
      <NCCardHeader
        title={t('shared.ncaDetail.indicatorSpecies.speciesDetected.title')}
        className='lg:grid-cols-[1fr_1fr]'
      />
      <NCCard2SectionLayout className='p-8 md:[&>*]:p-0' showDivider={false}>
        <TableTile data={speciesDetectedFact.value} />
      </NCCard2SectionLayout>
    </NCCard>
  );
};
